import { API_PUBLIC_DOMAIN } from '../constants';
import { handleError } from '../errorHandler';
import api from './api';

export const getJwt = (
  code: String,
  onSuccess: Function,
  onFailure: Function
) => {
  const body = {
    code: code,
  };
  api
    .post(API_PUBLIC_DOMAIN + '/jwt', body)
    .then((response) => onSuccess(response.data))
    .catch((error) => handleError(error, onFailure));
};
